import { makeVar } from "@/hooks/useVar.tsx";

export const vipVar = makeVar<string | undefined>(undefined);
